import isEmail from './is-email';
import isURL from './is-url';
import isPhoneNumber from './is-phone-number';
import isFullyURL from './is-fully-url';

export default {
  isEmail,
  isURL,
  isPhoneNumber,
  isFullyURL,
};
